module.exports = __webpack_public_path__ + "static/media/Автоваз-Light.46663785.webp";